module.exports = __webpack_public_path__ + "img/icon.bb7d0b24.svg";